import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AppConfig } from '../models/AppConfig.model';
import { firstValueFrom } from 'rxjs';
import { ConfigStore } from '../store/config.store';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  http = inject(HttpClient)
  configStore = inject(ConfigStore);

  async loadConfig(): Promise<void> {
    return firstValueFrom(
      this.http.get<AppConfig>('/config/app.config.json')
    ).then((data) => {
      this.configStore.setConfig(data);
    });
  }
}
